import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { KeyboardArrowDown, Email, Call } from '@material-ui/icons'
import { MessageReplyText } from 'mdi-material-ui'
import { Menu, MenuItem, ListSubheader } from '@material-ui/core'
import Button from 'components/theme/Button'
import { changeMessageType, changeTo, whatever } from 'actions/inbox'

class MessageTypeMenu extends Component {
	state = { anchorEl: null }

	// componentWillUnmount() {
	//   this.props.changeTo('')
	// }

	handleClick = (event) => {
		this.setState({ anchorEl: event.currentTarget })
	}

	handleClose = () => {
		this.setState({ anchorEl: null })
	}

	render() {
		const {
			messageType,
			conversationSelected,
			// conversation,
			contactSelected,
			to,
			style,
			contact,
		} = this.props
		const { anchorEl } = this.state

		// const contact = contactSelected
		//   ? contactSelected
		//   : conversation && conversation.contact
		//   ? conversation.contact
		//   : null

		const typeObj = {
			text: { icon: <MessageReplyText style={{ marginRight: 5 }} /> },
			email: { icon: <Email style={{ marginRight: 5 }} /> },
			call: { icon: <Call style={{ marginRight: 5 }} /> },
		}

		return (
			<Fragment>
				<Button
					// style={
					//   messageType === 'text'
					//     ? { position: 'absolute', left: 4, top: 7 }
					//     : { margin: '0 5px' }
					// }
					style={
						style
							? {
									margin: '0 0 0 5px',
									textTransform: 'none',
									maxWidth: 200,
									overflow: 'hidden',
									whiteSpace: 'nowrap',
									justifyContent: 'left',
									...style,
							  }
							: {
									margin: '0 0 0 5px',
									textTransform: 'none',
									maxWidth: 200,
									overflow: 'hidden',
									whiteSpace: 'nowrap',
									justifyContent: 'left',
							  }
					}
					variant="outlined"
					size="small"
					aria-owns={anchorEl ? 'simple-menu-message-type' : undefined}
					aria-haspopup="true"
					onClick={this.handleClick}
					disabled={!conversationSelected && !contactSelected}
				>
					{typeObj[messageType].icon}
					{to}
					<KeyboardArrowDown />
				</Button>
				<Menu
					id="simple-menu-message-type"
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={() => this.handleClose()}
				>
					{contact
						? [
								contact.phones && (
									<ListSubheader key="callListSubheader">Call</ListSubheader>
								),
								contact.phones &&
									contact.phones.map((phone, idx) => (
										<MenuItem
											key={`MessageTypeMenuCall${idx}`}
											onClick={() => {
												this.handleClose('call')
												this.props.changeTo('call', phone.number, contact.id)
												this.props.cancelAttachment()
												setTimeout(() => {
													this.props.whatever()
												}, 300)
											}}
										>
											{phone.number}
										</MenuItem>
									)),
								contact.phones && (
									<ListSubheader key="textListSubheader">Text</ListSubheader>
								),
								contact.phones &&
									contact.phones.map((phone, idx) => (
										<MenuItem
											key={`MessageTypeMenuText${idx}`}
											onClick={() => {
												this.handleClose('text')
												this.props.changeTo('text', phone.number, contact.id)
												this.props.cancelAttachment()
												setTimeout(() => {
													this.props.whatever()
												}, 300)
											}}
										>
											{phone.number}
										</MenuItem>
									)),
								contact.email && (
									<ListSubheader key="emailListSubheader">Email</ListSubheader>
								),
								contact.email &&
									contact.email.map((email, idx) => (
										<MenuItem
											key={`MessageTypeMenuEmail${idx}`}
											onClick={() => {
												this.handleClose('email')
												this.props.changeTo('email', email.address, contact.id)
												this.props.cancelAttachment()
												setTimeout(() => {
													this.props.whatever()
												}, 300)
											}}
										>
											{email.address}
										</MenuItem>
									)),
						  ]
						: null}
				</Menu>
			</Fragment>
		)
	}
}

export default connect(
	(state) => ({
		messageType: state.inbox.to.current.type,
		conversationSelected: state.inbox.conversationSelected,
		to: state.inbox.to.current.value,
		conversation: state.inbox.conversation,
		contactSelected: state.inbox.contactSelected,
		contact:
			(((state.inbox.contactSelected && state.inbox.contactSelected.id) ||
				state.inbox.conversationSelected) &&
				state.contacts.contactsWithEmailsByID[
					(state.inbox.contactSelected && state.inbox.contactSelected.id) ||
						state.inbox.conversationSelected
				]) ||
			{},
	}),
	(dispatch) =>
		bindActionCreators({ changeMessageType, changeTo, whatever }, dispatch),
)(MessageTypeMenu)
